/**
 * Generic date sort comparator for YYYY-MM-DD and DD-MM-YYYY formats
 * @param v1 First date string
 * @param v2 Second date string
 * @returns Comparison result for sorting
 */
export const dateComparator = (v1: any, v2: any): number => {
  const parseDate = (dateStr: string) => {
    if (!dateStr) return new Date(0);
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      // Try YYYY-MM-DD format first
      if (parts[0].length === 4) {
        return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      }
      // Otherwise try DD-MM-YYYY format
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
    return new Date(0);
  };

  const date1 = parseDate(v1 as string);
  const date2 = parseDate(v2 as string);

  return date1.getTime() - date2.getTime();
};

/**
 * Month-year sort comparator for formats like "2025 October" or "October 2025"
 * @param v1 First month-year string
 * @param v2 Second month-year string
 * @returns Comparison result for sorting
 */
export const monthYearComparator = (v1: any, v2: any): number => {
  const parseMonthYear = (str: string) => {
    const months: { [key: string]: number } = {
      january: 0, jan: 0,
      february: 1, feb: 1,
      march: 2, mar: 2,
      april: 3, apr: 3,
      may: 4,
      june: 5, jun: 5,
      july: 6, jul: 6,
      august: 7, aug: 7,
      september: 8, sep: 8, sept: 8,
      october: 9, oct: 9,
      november: 10, nov: 10,
      december: 11, dec: 11,
    };

    const parts = str.toLowerCase().trim().split(' ');
    // Handle both "2025 October" and "October 2025" formats
    const year = parseInt(parts[0]) || parseInt(parts[1]) || 0;
    const monthStr = isNaN(parseInt(parts[0])) ? parts[0] : parts[1];
    const month = months[monthStr] ?? 0;

    return new Date(year, month, 1);
  };

  const date1 = parseMonthYear(v1 as string);
  const date2 = parseMonthYear(v2 as string);

  return date1.getTime() - date2.getTime();
};
